/* eslint-disable no-case-declarations */
import { FETCH_MENU, FETCH_MENU_SUCCESS, PLP_NAVIGATION_PARAM, CLEAR_PLP_NAVIGATION_PARAM, FETCH_MENU_SUCCESS_UNCHANGED, FETCH_MENU_ERROR, FETCH_ITEM_DETAILS, FETCH_ITEM_DETAILS_SUCCESS, FETCH_ITEM_DETAILS_ERROR, UPDATE_SEARCH_RESULTS, CLEAR_SEARCH_RESULTS, RECOMMENDED_PRODUCT_SUCCESS, RECOMMENDED_PRODUCT_FAILURE, STORE_SCHEDULE_DATA, SET_ITEM_FAVOURITE, SET_ITEM_UN_FAVOURITE, SET_ITEM_FAVOURITE_SUCCESS, RESET_ITEM_FAVOURITE_SUCCESS, SET_ITEM_UNFAVOURITE_SUCCESS, RESET_ITEM_UNFAVOURITE_SUCCESS, SET_SELECTED_VIEW_MODE, GET_STORE_STATUS_ON_TIME_SUCCESS, RESET_MENU, RESET_FULFILLMENT } from '../../constants';
import { updatedRecommendedProducts } from './ProfileReducer';
import Strings from '../../constants/Strings';
import { MenuUtils } from '../../utils/MenuUtils';
const { filterCatalogByExclusionAndAvailability, getAllProductsFromCategories } = MenuUtils;
const { storeOpen } = Strings;
const initialState = {
    response: {},
    recommendedProducts: [],
    error: false,
    flatResponse: {},
    isLoading: false,
    isItemDetailsLoading: false,
    isItemFavouriteLoading: false,
    isItemUnFavouriteLoading: false,
    isItemFavouriteSuccess: false,
    isItemUnFavouriteSuccess: false,
    fulfillment: {
        scheduled: {},
    },
    lastModified: '',
    viewModeType: 'oneUp',
    exclusionsResponse: [],
    isFetchResponseLoaded: false,
    navigationPath: null,
    isMenuReset: false,
    timeSpecificResponse: [],
};
const menuReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_MENU:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_MENU_SUCCESS:
            const response = action.response;
            const categories = response?.categories?.[0]?.categories ?? [];
            const products = getAllProductsFromCategories(categories);
            // const categoryMapByUrl = keyBy(categories, 'url');
            // const categoryMapById = keyBy(categories, 'id');
            return {
                ...state,
                response,
                lastModified: action.lastModified,
                searchResults: response,
                isSearching: false,
                flatResponse: action.flatResponse,
                exclusionsResponse: action.exclusionsResponse,
                timeSpecificResponse: action.timeSpecificResponse,
                data: {
                    products,
                    menu: [...categories],
                    categories: [...categories],
                    filters: [],
                    sortBy: [],
                    dietary: [],
                    // productMapByUrl: getProductMapBy(products, 'url'),
                    // productMapById: getProductMapBy(products, 'id'),
                    // menuByUrl: categoryMapByUrl,
                    // menuById: categoryMapById,
                    // categoryMapByUrl,
                    // categoryMapById,
                },
                error: false,
                isLoading: false,
                isFetchResponseLoaded: true,
                isMenuReset: false
            };
        case FETCH_MENU_SUCCESS_UNCHANGED:
            return {
                ...state,
                //isSearching: false,
                error: false,
                isLoading: false,
                isFetchResponseLoaded: false,
                isMenuReset: false
            };
        case FETCH_MENU_ERROR:
            return {
                ...state,
                error: true,
                isLoading: false,
                isFetchResponseLoaded: false,
                isMenuReset: false
            };
        case RESET_MENU:
            return {
                ...state,
                searchResults: [],
                isSearching: false,
                flatResponse: {},
                exclusionsResponse: [],
                data: {
                    products: [],
                    menu: [],
                    categories: [],
                    filters: [],
                    sortBy: [],
                    dietary: [],
                },
                isMenuReset: true
            };
        case GET_STORE_STATUS_ON_TIME_SUCCESS: {
            const payload = action.payload;
            const response = action.response;
            const fulfillment = {
                asap: payload?.asap,
                scheduled: {
                    date: response?.timings?.scheduled?.date,
                    key: '',
                    time: payload?.futureDateTimeInEpochFormat,
                    isStoreOpen: response?.status?.currentStatus?.toLowerCase() === storeOpen?.toLowerCase(),
                },
            };
            return {
                ...state,
                fulfillment,
            };
        }
        case RESET_FULFILLMENT: {
            return {
                ...state,
                fulfillment: {
                    scheduled: {},
                }
            };
        }
        case STORE_SCHEDULE_DATA:
            return {
                ...state,
                fulfillment: action?.payload[2]?.fulfillment,
            };
        case FETCH_ITEM_DETAILS:
            return {
                ...state,
                isItemDetailsLoading: true,
            };
        case FETCH_ITEM_DETAILS_SUCCESS:
            const items = state?.items || [];
            items.push(action?.detailsResponse?.id);
            return {
                ...state,
                items,
                currentItemDetails: action.detailsResponse,
                flatListData: action.flatListData,
                isItemDetailsLoading: false,
            };
        case FETCH_ITEM_DETAILS_ERROR:
            return {
                ...state,
                isItemDetailsLoading: false,
            };
        case UPDATE_SEARCH_RESULTS:
            const cloneFlat = JSON.parse(JSON.stringify(state?.flatResponse) ?? '{}');
            const cloneResponse = JSON.parse(JSON.stringify(state?.response) ?? '{}');
            let suggestions = cloneFlat?.items?.filter((item) => action?.query
                .toLowerCase()
                .split(' ')
                .every((searchWord) => item?.name.toLowerCase().includes(searchWord)));
            const filteredSearchResult = suggestions?.filter((itemData) => state?.flatResponse?.categories?.find((category) => category?.id === itemData?.categoryId && !category?.isHidden) && itemData?.isHidden === false);
            const suggestionsMap = filteredSearchResult?.map((item) => {
                let backup = item;
                return {
                    ...item,
                    items: [backup],
                };
            });
            const removeDuplicateIds = suggestionsMap?.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
            const searchResultsFix = cloneResponse;
            searchResultsFix?.categories[0]?.categories?.splice(1);
            searchResultsFix.categories[0].categories[0].name =
                removeDuplicateIds?.length > 0 ? 'Search Results' : 'No Results';
            searchResultsFix.categories[0].categories[0].products = removeDuplicateIds;
            searchResultsFix.categories[0].categories[0].categories = [];
            searchResultsFix.categories[0].products = [];
            searchResultsFix.products = [];
            action.callback?.(searchResultsFix);
            return {
                ...state,
                searchResults: searchResultsFix,
                query: action?.query,
                isSearching: true,
                viewMode: 'search',
            };
        case CLEAR_SEARCH_RESULTS:
            const scheduledDateAndTime = state?.fulfillment?.scheduled ?? {};
            const responseClear = filterCatalogByExclusionAndAvailability(action.menuResponse, action.exclusionsResponse, scheduledDateAndTime);
            return {
                ...state,
                responseClear,
                searchResults: [responseClear],
                viewMode: 'carousel',
                isSearching: false,
            };
        case RECOMMENDED_PRODUCT_SUCCESS:
            const detailsResponse = action.detailsResponse?.length &&
                action.detailsResponse?.map((data) => {
                    return {
                        id: data.productId,
                        displayOrder: data.displayOrder,
                        name: data.productName,
                    };
                });
            return {
                ...state,
                recommendedProducts: updatedRecommendedProducts(detailsResponse, state.flatResponse),
            };
        case RECOMMENDED_PRODUCT_FAILURE:
            return {
                ...state,
                recommendedProducts: [],
                error: true,
            };
        case SET_ITEM_FAVOURITE:
            return {
                ...state,
                isItemFavouriteLoading: true,
            };
        case SET_ITEM_FAVOURITE_SUCCESS:
            return {
                ...state,
                isItemFavouriteLoading: false,
                isItemFavouriteSuccess: true,
            };
        case RESET_ITEM_FAVOURITE_SUCCESS:
            return {
                ...state,
                isItemFavouriteSuccess: false,
            };
        case SET_ITEM_UN_FAVOURITE:
            return {
                ...state,
                isItemUnFavouriteLoading: true,
            };
        case SET_ITEM_UNFAVOURITE_SUCCESS:
            return {
                ...state,
                isItemUnFavouriteLoading: false,
                isItemUnFavouriteSuccess: true,
            };
        case RESET_ITEM_UNFAVOURITE_SUCCESS:
            return {
                ...state,
                isItemUnFavouriteSuccess: false,
            };
        case SET_SELECTED_VIEW_MODE:
            return {
                ...state,
                viewModeType: action.payload,
            };
        case PLP_NAVIGATION_PARAM:
            return {
                ...state,
                navigationPath: action.path,
            };
        case CLEAR_PLP_NAVIGATION_PARAM:
            return {
                ...state,
                navigationPath: null,
            };
        default:
            return state;
    }
};
export { menuReducer };
